import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { LoadingService } from 'src/app/services/loading.service';
import { RedirectService } from 'src/app/services/redirect.service';
import { StepsNotClientTypes } from 'src/app/shared/enums';
import { UiActions } from 'src/app/store/actions';
import { OnboardingProductsStore } from 'src/app/store/store';

@Component({
  selector: 'app-no-client-flow',
  templateUrl: './no-client-flow.component.html',
  styleUrls: ['./no-client-flow.component.scss']
})
export class NoClientFlowComponent implements OnInit {

  constructor(
    public loadingService: LoadingService,
    private store: Store<OnboardingProductsStore.AppState>,
    private redirectService: RedirectService
  ) { }

  steps$ = this.store.pipe(
    select(OnboardingProductsStore.selectors.stepsNoClient)
  );
  Step = StepsNotClientTypes;
  ngOnInit(): void {
    this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_PUBLIC_LANDING }));
  }

  loadRetry() {
    switch (this.redirectService.getRedirect()) {
      case StepsNotClientTypes.STEP_PUBLIC_LANDING: {
        this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_PUBLIC_LANDING }));
        break;
      }
      default: {
        this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_SERVICE_ERROR }));
      }
    }
    this.loadingService.loading = true;
  }
}
